module.exports = __webpack_public_path__ + "img/signup-grp2.952d0b67.png";